import React, { ReactNode } from 'react';

interface InfoCardItemProps {
  icon: ReactNode;
  label: string;
  value: string | ReactNode;
  isBlock?: boolean; // If true, value takes full width below label
  className?: string;
}

export const InfoCardItem: React.FC<InfoCardItemProps> = ({ icon, label, value, isBlock = false, className = '' }) => {
  return (
    <div className={`flex items-start py-2 ${isBlock ? 'flex-col' : ''} ${className}`}>
      <div className={`flex items-center flex-shrink-0 ${isBlock ? 'mb-1' : 'mr-3 w-28'}`}>
        <span className="text-brand-teal mr-2">{icon}</span>
        <span className="text-sm font-medium text-gray-600 dark:text-dark-text-secondary">{label}:</span>
      </div>
      <div className={`text-sm text-gray-900 dark:text-dark-text-primary ${isBlock ? 'pl-7' : 'flex-grow break-words'}`}>
        {value}
      </div>
    </div>
  );
};